<template>
  <el-dialog title="人员选择" :visible.sync="linkDialog" v-dialogDrag :append-to-body="true" width="56%" class="choose-box">
    <!-- 单选不显示选中人员列表 -->
    <div class="choose-people" v-if="checkType != 'radio'">
      <div v-for="(item, index) in personIds" class="people" :key="index">
        <el-tag size="small" @close="closeTag(index)" closable>{{
          item.name
        }}</el-tag>
      </div>
    </div>
    <ioc-table ref="multipleTable" :data="personData" :option="personOptions" :page="personPage" @size-change="personChangeSize" @current-change="currentChange" @search-change="searchList" @search-reset="personReset" @radio-change="personRadio" @selection-change="personSelection">
    </ioc-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancleChoose" type="info">取消</el-button>
      <el-button type="primary" @click="confirmChoose">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { api } from "../api";
import utils from "@src/common/utils";
import personOptions from "../const/table";
export default {
  props: {
    checkType: {
      type: String,
      default() {
        return "";
      },
    },
  },
  watch: {
    checkType: {
      handler: function (old, newVal) {
        if (old == "select") {
          this.personOptions.radio = false;
          this.personOptions.selection = true;
        } else if (old == "radio") {
          this.personOptions.radio = true;
          this.personOptions.selection = false;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      personOptions: personOptions(),
      linkDialog: false,
      personData: [],
      personPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      personSearch: {},
      personIds: [],
      actionBtn: "",
      queryForm: {
        departmentName: "",
        departmentCodeList: [],
      },
    };
  },
  mounted() {
    this.getPersonList();
  },
  methods: {
    open(id, type) {
      // console.log(id)c
      // console.log(this.personData)
      this.linkDialog = true;
      if (type == "radio") {
        this.personIds = id || [];
        return;
      }
      this.$nextTick(() => {
        id && this.toggleSelection(id);
      });
    },
    closeTag(index) {
      let delItem = this.personIds[index];
      this.personIds.splice(index, 1);
      if (this.checkType == "radio") {
        this.$refs.multipleTable.templateRadio = "";
        return;
      }
      this.$refs.multipleTable.$refs.multipleTable.toggleRowSelection(delItem);
      this.$refs.multipleTable.$refs.multipleTable.toggleRowSelection(
        delItem,
        false
      );
    },
    // 选中回显
    toggleSelection(id) {
      id.forEach((row) => {
        this.$refs.multipleTable.$refs.multipleTable.toggleRowSelection(
          row,
          true
        );
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 获取人员选择弹框中人员列表
    getPersonList() {
      const params = {};
      params.personnelType = 1;
      params.workNo = this.personSearch.workNo;
      params.name = this.personSearch.name;
      params.beginTime = "";
      params.status = 1;
      params.endTime = "";
      params.departmentCodeList = this.queryForm.departmentCodeList;
      params.pageNum = this.personPage.pageNum;
      params.pageSize = this.personPage.pageSize;
      this.$fetch(api.getPersonList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        if (this.checkType == "radio") {
          this.$refs.multipleTable.templateRadio = "";
          if (this.personIds.length)
            response.returnObj.list.forEach((el, index) => {
              if (el.personnelCode == this.personIds[0].personnelCode) {
                this.$refs.multipleTable.templateRadio = index;
              }
            });
        }
        this.personData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.personPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },
    // 人员选择确认弹框
    // confirmChoose(flag) {
    //   if (this.personIds.length === 0) {
    //     this.$message({
    //       type: "warning",
    //       duration: 2000,
    //       message: "请选择人员",
    //     });
    //     return;
    //   } else {
    //     this.$emit("confirmCallBack", this.personIds);
    //     this.cancleChoose();
    //   }
    // },
    confirmChoose(flag) {
      this.$emit("confirmCallBack", this.personIds);
      this.cancleChoose();
    },
    // 人员选择取消弹框
    cancleChoose() {
      this.linkDialog = false;
      this.personIds = [];
    },
    // 单选
    personRadio(item) {
      // console.log(item)
      this.personIds = [item];
    },
    // 多选
    personSelection(items) {
      console.log(items);
      this.personIds = items.map((item) => {
        return item;
      });
    },
    // 员工弹框修改每页数据数量
    personChangeSize(val) {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = val;
      this.getPersonList();
    },
    currentChange(val) {
      this.personPage.pageNum = val;
      this.getPersonList();
    },
    searchList(param) {
      this.personSearch = Object.assign(param);
      this.personPage.pageNum = 1;
      this.getPersonList();
    },
    personReset() {
      this.queryForm.departmentName = "";
      this.queryForm.departmentCodeList = [];
      this.getPersonList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.choose-box {
  .choose-people {
    display: flex;
    flex-wrap: wrap;
    // height: 35px;
    .people {
      margin: 0px 5px 5px;
    }
  }
  :deep .el-dialog__body {
    padding: 15px 20px !important;
  }

  .el-dialog__body {
    .ioc-table {
      height: 480px !important;
      .ioc-table__search {
        .el-range-editor {
          width: 360px;
        }
        .tree-container {
          @include set_theme_color(background-color, item-active-bg-color);
          position: absolute;
          bottom: -255px;
          width: 100%;
          z-index: 999999;
          height: 250px;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
}
</style>
